module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-waste--cover.1809bf0e.jpg";